import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 2rem 1rem',
  flexGrow: 1,
}));

export const MainTitle = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.75rem',
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2.5rem',
  justifyContent: 'flex-start',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1rem',
  flexWrap: 'wrap',
}));

export const AlignStatusAndProof = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '1rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',

  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-end',
  },
}));

export const AlignMobileButton = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  position: 'fixed',
  right: '1rem',
  bottom: '3.2rem',
}));

export const ButtonsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
    width: '100%',
  },
}));
